<template>
    <div id="header" class="header">
        <div id="header-inner-top" class="pdt-10">
            <div class="goto-back"> <a href="javascript:history.back(-1)">뒤로가기</a> </div>
            <div class="main-tit pdt-15" style="width:100%;">
                <h2 class="subtitle">{{ headerName }}</h2>
            </div>
            <div class="top-r2">
                <div :class="['btn-like', likeVal ? 'on' : '']"><a href="javascript: void(0);" @click.prevent="like()">좋아요</a></div>
                <div class="btn-share"><a href="javascript: void(0);" @click.prevent="shareFacebook()">공유하기</a></div>
            </div>
        </div>
    </div>
</template>

<script>
import { $_WC, $_TYPE, $_DKD } from '@/confs/common.const.js';
import commonConstMixin from "@/stores/common.const.mixin.js"
import {mapGetters} from "vuex";
import commonApi from "@/apis/common.api.js";

export default {
    props: {
        headerName: {
            type: String,
            default: ''
        }
    },
    data(){
        return {
            href: window.location.href,
            guidVal: '',
            likeVal: false,
            url: '',
        }
    },
    created() {
        this.$store.dispatch('FETCH_LOGO_FILE');

        this.$store.dispatch('FETCH_AIRSPACE');
        setInterval(()=>{
            this.$store.dispatch('FETCH_AIRSPACE');
        }, 1000 * 60 * 10);

        this.url = window.location.pathname + '' + window.location.search;
        if(localStorage.getItem('guid') === null) {
            let guid = this.guid();
            localStorage.setItem('guid', guid);
            this.guidVal = guid;
        } else {
            this.guidVal = localStorage.getItem('guid');
            let q = 'where=val1::' + encodeURIComponent(this.guidVal);
            q += '&where=val2::' + encodeURIComponent(this.url);
            commonApi.fetchRepoDataList($_DKD.LIKE, q)
                .then(res => {
                    if(res.data.data.length > 0) {
                        if(res.data.data[0].val5 === 'Y') {
                            this.likeVal = true;
                        } else {
                            this.likeVal = false;
                        }
                    }
                });
        }
    },
    computed: {
        ...mapGetters({
            logoFile: 'getLogoFile',
            airSpace: 'getAirSpace',
            pageNm: 'getPageNm',
            pageCate: 'getPageCate',
        }),
        logoImg() {
            if(typeof this.logoFile.comnFlSqno !== 'undefined') {
                return $_WC.fileBaseURL + '/image/' + this.logoFile.comnFlSqno;
            }
            return '';
        },
        weatherImg(){
            if(typeof this.airSpace.skyValue !== $_TYPE.UNDEF) {
                return $_WC.assets + 'img/spaceSkyCd.' + this.airSpace.skyValue + '.png';
            }
            return '';
        },
    },
    methods: {
        shareTwitter(){
            let sendText = this.pageNm;
            let sendUrl = this.href;
            console.log(sendText, sendUrl);
            window.open("https://twitter.com/intent/tweet?text=" + sendText + "&url=" + sendUrl);
        },

        shareFacebook(){
            let sendUrl = this.href;
            console.log(sendUrl);
            window.open("http://www.facebook.com/sharer/sharer.php?u=" + sendUrl);
        },
        like(){
            if(this.pageNm !== '') {
                let formatDay = (new Date()).format('yyyyMMdd');
                let timestamp = new Date().getTime();
                let val = this.likeVal ? 'N' : 'Y';
                let data = {'basdtVal': formatDay, 'val1': this.guidVal, 'val2': this.url, 'val3': this.pageCate, 'val4': this.pageNm, 'val5': val, 'val6': timestamp};
                axios.post($_WC.apiBaseURL + '/repos/' + $_DKD.LIKE, data).then(res => {
                    this.likeVal = !this.likeVal;
                });
            }
        },
        guid() {
            return this._p8() + this._p8(true) + this._p8(true) + this._p8();
        },
        _p8(s){
            let p = (Math.random().toString(16)+"000000000").substr(2,8);
            return s ? "-" + p.substr(0,4) + "-" + p.substr(4,4) : p ;
        },
    },
    mixins: [commonConstMixin],
}
</script>
<style>
.header-logo-img {
    width: inherit;
    height: inherit;
}
</style>
